export class PerformanceMonitoringVO {
    private _averageFPS: number;
    private _maxFps: number;
    private _averageTotalMemoryUsageInMB: number;
    private _averagePrivateMemoryUsageInMB: number;
    private _freeSpaceOnDeviceInMB: number;
    private _loginTime: number;
    private _loginTimeMs: number;
    private _downloadRateInKBs: number;
    private _downloadContentSizeExternalInKB: number;
    private _downloadContentSizeLocalInKB: number;
    private _downloadContentAmountExternal: number;
    private _downloadContentAmountLocal: number;
    private _geoIpRequestTimeInMS: number;

    public toString(): string {
        let values: string[] = [
            "averageFPS=" + this.averageFPS,
            "maxFps=" + this.maxFps,
            "averageTotalMemoryUsageInMB=" + this.averageTotalMemoryUsageInMB,
            "averagePrivateMemoryUsageInMB=" + this.averagePrivateMemoryUsageInMB,
            "freeSpaceOnDeviceInMB=" + this.freeSpaceOnDeviceInMB,
            "loginTime=" + this.loginTime,
            "loginTimeMs=" + this.loginTimeMs,
            "downloadRateInKBs=" + this.downloadRateInKBs,
            "downloadContentSizeExternalInKB=" + this.downloadContentSizeExternalInKB,
            "downloadContentSizeLocalInKB=" + this.downloadContentSizeLocalInKB,
            "downloadContentAmountExternal=" + this.downloadContentAmountExternal,
            "downloadContentAmountLocal=" + this.downloadContentAmountLocal,
            "geoIpRequestTimeInMS=" + this.geoIpRequestTimeInMS
        ];
        return "PerformanceMonitoringVO { " + values.join(", ") + " }";
    }

    public set averageFPS(value: number) {
        this._averageFPS = value;
    }

    public get averageFPS(): number {
        return this._averageFPS || 0;
    }

    public set maxFps(value: number) {
        this._maxFps = value;
    }

    public get maxFps(): number {
        return this._maxFps || 0;
    }

    public set averageTotalMemoryUsageInMB(value: number) {
        this._averageTotalMemoryUsageInMB = value;
    }

    public get averageTotalMemoryUsageInMB(): number {
        return this._averageTotalMemoryUsageInMB || 0;
    }

    public set averagePrivateMemoryUsageInMB(value: number) {
        this._averagePrivateMemoryUsageInMB = value;
    }

    public get averagePrivateMemoryUsageInMB(): number {
        return this._averagePrivateMemoryUsageInMB || 0;
    }

    public set freeSpaceOnDeviceInMB(value: number) {
        this._freeSpaceOnDeviceInMB = value;
    }

    public get freeSpaceOnDeviceInMB(): number {
        return this._freeSpaceOnDeviceInMB || 0;
    }

    public set loginTime(value: number) {
        this._loginTime = value;
    }

    public get loginTime(): number {
        return this._loginTime || 0;
    }

    public set loginTimeMs(value: number) {
        this._loginTimeMs = value;
    }

    public get loginTimeMs(): number {
        return this._loginTimeMs || 0;
    }

    public set downloadRateInKBs(value: number) {
        this._downloadRateInKBs = value;
    }

    public get downloadRateInKBs(): number {
        return this._downloadRateInKBs || 0;
    }

    public set downloadContentSizeExternalInKB(value: number) {
        this._downloadContentSizeExternalInKB = value;
    }

    public get downloadContentSizeExternalInKB(): number {
        return this._downloadContentSizeExternalInKB || 0;
    }

    public set downloadContentSizeLocalInKB(value: number) {
        this._downloadContentSizeLocalInKB = value;
    }

    public get downloadContentSizeLocalInKB(): number {
        return this._downloadContentSizeLocalInKB || 0;
    }

    public set downloadContentAmountExternal(value: number) {
        this._downloadContentAmountExternal = value;
    }

    public get downloadContentAmountExternal(): number {
        return this._downloadContentAmountExternal || 0;
    }

    public set downloadContentAmountLocal(value: number) {
        this._downloadContentAmountLocal = value;
    }

    public get downloadContentAmountLocal(): number {
        return this._downloadContentAmountLocal || 0;
    }

    public set geoIpRequestTimeInMS(value: number) {
        this._geoIpRequestTimeInMS = value;
    }

    public get geoIpRequestTimeInMS(): number {
        return this._geoIpRequestTimeInMS || 0;
    }
}
